import { resolveImagePath } from "@/utils/imageMap";

export function ServicesPreview() {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <h3 className="text-sm md:text-base font-medium text-gray-500 mb-4 uppercase tracking-wide">
            Our Services
          </h3>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-medium text-gray-900 tracking-wide">
            COUNSELING & THERAPY
          </h2>
        </div>

        {/* Images grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={resolveImagePath("/images/therapy-environment-1.jpg")}
              alt="Therapeutic environment with candles and wine glasses"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={resolveImagePath("/images/therapy-environment-2.jpg")}
              alt="Cozy therapy room setting"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={resolveImagePath("/images/therapy-environment-3.jpg")}
              alt="Comfortable therapy environment with plants"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
        </div>
      </div>
    </section>
  );
}